import React from 'react';
import * as S from './Footer.module.css';
import FooterLogo from '@images/footer_logo.svg';
import BuyanovaLogo from '@images/buyanova_logo.svg';

export const Footer: React.FunctionComponent = () => (
  <footer className={S.footer}>
    <a
      className={S.footerLink}
      href="https://news.mail.ru/"
      target="_blank"
      rel="noreferrer"
    >
      <FooterLogo />
    </a>
    <div className={S.footerLink}>
      <BuyanovaLogo />
    </div>
  </footer>
);
